import {FC} from 'react';

type HealthDeclarationSummaryQuestionProps = {
  question: string;
  answers: any;
  type: string;
};

const HealthDeclarationSummaryQuestion: FC<HealthDeclarationSummaryQuestionProps> = ({question, answers, type}) => {
  return (
    <div className='flex justify-between flex-wrap mb-3'>
      <div className='font-Outfit text-17 font-semibold text-navy-primary pb-1 w-full'>
        {question}
      </div>
      {answers.map((el: any) => {
        if (type === 'fill') {
          return (
            <div
              key={el.answer_id}
              className='flex w-full justify-between flex-wrap py-1 border-b border-navy-primary'
            >
              <div className='text-md mb-2'>
                {el.answer_name}
                {el.content}
              </div>
              <div className='w-full'>{el.value}</div>
            </div>
          );
        } else {
          return (
            <div
              key={el.answer_id}
              className='flex w-full justify-between py-1 border-b border-navy-primary'
            >
              <div className='text-md'>
                {el.answer_name}
                {el.content}
              </div>
              <div className='font-semibold text-md'>
                {el.value === 'yes' ?
                  'Ja' :
                  el.value === 'no' ?
                  'Nej' :
                  'Offyld'}
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};

export default HealthDeclarationSummaryQuestion;
